import { BehaviorSubject, Observable } from 'rxjs';

export interface ViewportData {
  width: number;
  height: number;
}

export abstract class ViewportService {
  abstract viewPortChanged$: Observable<ViewportData> | null;

  abstract isMobile$: Observable<boolean>;

  abstract isTablet$: Observable<boolean>;

  abstract getViewportData(): ViewportData;
}
